import { render, staticRenderFns } from "./candidate-availability-item.vue?vue&type=template&id=bf0e8688&scoped=true&"
import script from "./candidate-availability-item.vue?vue&type=script&lang=js&"
export * from "./candidate-availability-item.vue?vue&type=script&lang=js&"
import style0 from "./candidate-availability-item.vue?vue&type=style&index=0&id=bf0e8688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e8688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
